import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { nextTick, ref } from 'vue';
import { getScrollTop } from '@/shared/util';
import { useNavBarHeight } from '@/shared/composables/navBarHeight';
var __default__ = {
    name: 'XForm',
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        colon: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        labelWidth: [
            Number,
            String
        ],
        labelAlign: String,
        inputAlign: String,
        scrollToError: Boolean,
        validateFirst: Boolean,
        errorMessageAlign: String,
        showError: {
            type: Boolean,
            default: true
        },
        showErrorMessage: {
            type: Boolean,
            default: true
        },
        submitOnEnter: {
            type: Boolean,
            default: true
        },
        validateTrigger: {
            type: String,
            default: 'onBlur'
        }
    },
    emits: [
        "failed"
    ],
    setup: function setup(__props, param) {
        var expose = param.expose, emit = param.emit;
        var props = __props;
        var navBarHeight = useNavBarHeight();
        var onFailed = function onFailed(errorInfo) {
            if (props.scrollToError) {
                var errors = errorInfo.errors;
                if (errors[0].name) {
                    nextTick(function() {
                        // 基于vant-form定位后的scrollTop再次移动一个nav-bar的高度的位置, 保证输入框不会被nav-bar遮挡
                        window.scrollTo(0, getScrollTop(window) - navBarHeight);
                    });
                }
            }
            emit('failed', errorInfo);
        };
        var form = ref(null);
        // @exposed-api
        var submit = function submit() {
            var _form_value;
            (_form_value = form.value) === null || _form_value === void 0 ? void 0 : _form_value.submit();
        };
        // @exposed-api
        var validate = function validate(name) {
            var _form_value;
            (_form_value = form.value) === null || _form_value === void 0 ? void 0 : _form_value.validate(name);
        };
        // @exposed-api
        var resetValidation = function resetValidation(name) {
            var _form_value;
            (_form_value = form.value) === null || _form_value === void 0 ? void 0 : _form_value.resetValidation(name);
        };
        // @exposed-api
        var scrollToField = function scrollToField(name, options) {
            var _form_value;
            (_form_value = form.value) === null || _form_value === void 0 ? void 0 : _form_value.scrollToField(name, options);
        };
        expose({
            submit: submit,
            validate: validate,
            resetValidation: resetValidation,
            scrollToField: scrollToField
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            navBarHeight: navBarHeight,
            onFailed: onFailed,
            form: form,
            submit: submit,
            validate: validate,
            resetValidation: resetValidation,
            scrollToField: scrollToField
        };
    }
}));
